import {
  Play, Radio, Search, Sparkles, ShieldCheck, Send, TrendingUp, Flag,
} from "lucide-react";

export const STEPS = [
  {
    key: "intro", phase: "1 · Scenario", icon: Play,
    title: "FTD lead who stopped answering calls",
    explain: "Marco De Luca (ONET-1042) is a verified Italian lead who registered 9 days ago, visited the deposit page three times, and has not answered five consecutive calls. This walkthrough performs the real O.N.E.Tech workflow on his record — every step below mutates live demo state and writes to the audit log.",
  },
  {
    key: "detect", phase: "2 · Detect", icon: Radio, action: "simulate-signal", ran: (c) => !!c.workflow.signal,
    title: "An incoming signal arrives from a connected system",
    explain: "O.N.E.Tech continuously listens to the broker's stack — CRM, VoIP, web sessions, KYC, payments and MT5 (all simulated here). The moment a relevant event occurs, it lands on the client's timeline and re-prioritises the queue.",
  },
  {
    key: "identify", phase: "3 · Identify", icon: Search,
    title: "Lifecycle stage, exact blockage and priority score",
    explain: "The engine places the client on the lifecycle (Lead → FTD → … → Withdrawal), pinpoints where he is stuck, explains the detected reason in plain language, and computes a 0-99 risk/opportunity score with an estimated commercial value.",
  },
  {
    key: "decide", phase: "4 · Decide", icon: Sparkles, action: "generate-nba", ran: (c) => !!c.workflow.nba,
    title: "Deterministic next best action, language, channel and timing",
    explain: "Rule-based decisioning selects the next best action for this pattern: for call-avoidant FTD leads it prioritises human contact with multilingual re-engagement. It also selects the approved language, the best-performing channel and a compliant send time.",
  },
  {
    key: "govern", phase: "5 · Govern", icon: ShieldCheck,
    title: "Licence, jurisdiction, consent and policy checks",
    explain: "Before anything is sent, the governance layer validates jurisdiction, channel permission, approved language, restricted-claims and the contact window — then decides whether the action may auto-execute or must be routed for human approval.",
  },
  {
    key: "execute", phase: "6 · Execute", icon: Send, action: "execute", ran: (c) => c.workflow.execution === "executed",
    title: "The approved communication is executed",
    explain: "Once approved (automatically or by a human), the message is delivered over the selected channel. Execution changes the client state, appends to the communication history and creates a timestamped audit entry.",
  },
  {
    key: "measure", phase: "7 · Measure", icon: TrendingUp, action: "write-back", ran: (c) => c.workflow.crm_writeback,
    title: "CRM write-back and recovered-revenue attribution",
    explain: "The outcome is written back to the CRM record and timeline, the lifecycle stage advances, and the recovered commercial value is attributed on the dashboard — closing the loop from signal to revenue.",
  },
];

export const GUIDED_CLIENT_ID = "ONET-1042";
export const GUIDED_FLAG_ICON = Flag;
